import { useSelector } from 'react-redux'
import { selectTrafficAreasListStructure } from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useSearchList } from './useSearchList'

export function useFilter() {
  const { editing } = useEditingStateWithCtx('trafficArea')
  const { query, setQuery } = useSearchList()
  const listStructure = useSelector(selectTrafficAreasListStructure)

  return {
    query,
    editing,
    setQuery,
    noEntries: listStructure.totalItems === 0,
  }
}
